import client from "./client";

export default {

    async getCharges(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/charges', filters)));
    },
    async getChargesForTenancy(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/tenancy-charges', filters)));
    },
    async getChargesWithPayments(filters) {
        return client.parseResponse(await client.get('/charge-payments', filters));
    },
    async getChargePayments(filters) {
        return client.parseResponse(await client.get('/charge-payments', filters));
    },
    async getCharge(id) {
        return client.parseResponse(await client.get('/charges/' + id));
    },
    async createCharge(data) {
        return client.parseResponse(await client.post('/charges', data))
    },
    async editCharge(data) {
        return client.parseResponse(await client.put('/charges/' + data.id, data))
    },
    async deleteCharge(data) {
        return client.parseResponse(await client.delete('/charges/' + data.id))
    },

    async exportChargesReport(filters) {
        return client.parseResponse(await client.get('/export-charges', filters, {responseType: 'blob'}));
    }
}
